// AI Generated Component
import { Component, OnInit, Input } from '@angular/core';
import { CheckForDuplicatesService } from '@client/app/core/services/check-for-duplicates/check-for-duplicates.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'spelling-pages-dialog',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header
                    [header]="('Pages with misspelling - ' | translate) + ' ' + word.word"
                    [subHeaderTooltipEnable]="false"
                    panelClass="row"
                    panelLeftClass="col-32 col-md-28 col-lg-30"
                    panelRightClass="col-16 col-md-20 col-lg-18"
                    [subHeader]="('Total pages with misspelling: ' | translate) + ' ' + (pages.total | monNumber)">
                <page-header-content>
                    <div class="d-flex mon-dialog-delay-fadein">
                        <div class="p-1 mr-1">
                            <a *ngIf="'table_filters' | activeFeature"
                               (click)="isFiltersOpen = !isFiltersOpen"
                               class="text-link inline-block outer-t-small cursor-pointer">
                                <span class="fas fa-filter fa-lg"></span>
                            </a>
                        </div>

                        <div class="p-1">
                            <csv-export-button  [exports]="exports"
                                                clsSize="py-2 px-3"
                                                clsMargin="mr-0">
                            </csv-export-button>
                        </div>

                        <div class="col-38 col-md-43 col-lg-43 inner-r-large mt-1">
                            <table-search [minSearchLength]="3"
                                          class="block outer-r-small"
                                          theme="grey-theme"
                                          [placeholderTxt]="'Search...' | translate"
                                          [model]="search"
                                          (getPage)="onSearch($event)">
                            </table-search>
                        </div>
                    </div>
                </page-header-content>
            </page-header>
        </div>

        <div class="mon-dialog-body">
            <div class="card panel-monsido-card outer-t outer-r outer-l">
                <div class="card-body">
                    <div class="mb-4 merge-r-16 merge-l-16 merge-t-10" *ngIf="isFiltersOpen">
                        <table-filters [(open)]="isFiltersOpen"
                                       [(ngModel)]="filters"
                                       name="filters"
                                       [filters]="availableFilters"
                                       *ngIf="'table_filters' | activeFeature"
                                       (onChanges)="updateFilters($event);getPage();">
                        </table-filters>
                    </div>

                    <pages-misspellings-table
                            [pages]="pages"
                            [disablePagination]="false"
                            [progress]="progress"
                            (onPageChange)="onPageChange($event)"
                            (onPerPageChange)="onPageSizeChange($event)"
                            (onSortPageChange)="onSortPage($event.direction, $event.by)"
                            [currentSort]="currentSort"
                            [target]="pageDetailTarget"
                            (callBack)="onPageDetailsClose()">
                    </pages-misspellings-table>
                </div>
            </div>
        </div>
    `,
})
export class SpellingPagesDialogComponent extends BaseContainerComponentController implements OnInit {
    @Input() word: any;
    @Input() pageDetailTarget: any;

    progress: any = [];
    pages: any = [];
    override currentSort: any = { by: 'priority_score', direction: 'desc' };
    exports: any[] = [];
    allLabels: any;

    constructor (
        private checkForDuplicatesService: CheckForDuplicatesService,
    ) {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit (): void {
        this.pages = [];
        this.progress = [];

        this.selectedLabels = [];
        this.selectedLanguages = [];

        this.currentSort = { by: 'priority_score', direction: 'desc' };

        this.filters = { labels: [], languages: [] };
        this.availableFilters = {
            labels: [],
            languages: [],
        };
        this.isFiltersOpen = false;
        this.getLabels();
        this.getLanguages();
        this.getPage();
        this.exports = [
            {
                data: {
                    category: 'pages_with_specific_potential_misspelling',
                    category_ref: this.word.word,
                },
            },
        ];
    }

    override getPage = (): void => {
        const params: any = {
            page: this.page,
            search: this.search,
            page_size: this.pageSize,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        if (this.selectedLabels && this.selectedLabels.length > 0) {
            params['labels[]'] = this.selectedLabels;
        }

        if (this.selectedLanguages && this.selectedLanguages.length > 0) {
            params['languages[]'] = this.selectedLanguages;
        }

        this.progress = this.spellingRepoService.getAllPagesWithError(this.word.id, params, {}).then(
            (data: any) => {
                this.checkForDuplicatesService.checkForDuplicatePages(data);
                this.pages = data;
            },
            () => {
                this.pages = [];
                this.pages.total = 0;
            },
        );
    };
}
